import type { FC } from 'react';
import { LogoHorizontal } from './logo-horizontal.component';
import { LogoVertical } from './logo-vertical.component';
import { StyledLink } from '../Typography/typography.styles';
import { PATH } from '../../app.type';

type Props = {
  position: 'horizontal' | 'vertical';
};

export const Logo: FC<Props> = (props) => {
  const { position } = props;
  const Component = position === 'horizontal' ? LogoHorizontal : LogoVertical;

  return (
    <StyledLink title="Busem w Trasę" to={PATH.HOME}>
      <Component />
    </StyledLink>
  );
};
